/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuCrossOwnerDocsSendToCounterpartPartialUpdateRequest = {} | null | undefined;
export type SvuCrossOwnerDocsSendToCounterpartPartialUpdateResponse = any;

export type SvuCrossOwnerDocsSendToCounterpartPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_cross_owner_docs/{id}/send_to_counterpart/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_send_to_counterpart_partial_update
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSendToCounterpartPartialUpdateOperation = ({
  id,
  ...rest
}: SvuCrossOwnerDocsSendToCounterpartPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_cross_owner_docs/${id}/send_to_counterpart/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_cross_owner_docs/{id}/send_to_counterpart/' };
  };

/**
 * PATCH /dmx-server/svu_cross_owner_docs/{id}/send_to_counterpart/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_send_to_counterpart_partial_update
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsSendToCounterpartPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuCrossOwnerDocsSendToCounterpartPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuCrossOwnerDocsSendToCounterpartPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
